export const getStoredUser = () => {
  try {
    const user = localStorage.getItem("user");
    return user ? JSON.parse(user) : null;
  } catch {
    return null;
  }
};

export const setStoredUser = (user) => {
  if (!user) {
    localStorage.removeItem("user");
    return;
  }

  localStorage.setItem("user", JSON.stringify(user));
};

export const mergeStoredUserProfile = (profileUpdates = {}, topLevelUpdates = {}) => {
  const currentUser = getStoredUser();
  if (!currentUser) {
    return null;
  }

  const nextUser = {
    ...currentUser,
    ...topLevelUpdates,
    profile: {
      ...(currentUser.profile || {}),
      ...profileUpdates,
    },
  };

  setStoredUser(nextUser);
  return nextUser;
};

export const syncStoredMerchantIdentity = (merchantData) => {
  if (!merchantData) {
    return null;
  }

  const merchantId = merchantData.id || merchantData._id || merchantData.merchantId;

  return mergeStoredUserProfile(
    {
      merchantId,
      businessName: merchantData.businessName,
      bankAccountHolderName: merchantData.bankAccountHolderName,
      bankAccountLast4: merchantData.bankAccountLast4,
      bankSortCode: merchantData.bankSortCode,
    },
    {
      email: merchantData.email,
      phone: merchantData.phone,
    }
  );
};